const merge = require('lodash/fp/merge');
const extend = require('lodash/extend');

const boundaryString = '1439751438138';
const boundarySeparator = '--';
const newLine = '\r\n';
const httpVersion = 'HTTP/1.1';
const batchItemContent = 'Content-Type: application/http; msgtype=request';
const batchRequestContent = `multipart/mixed; boundary=${boundaryString}`;

const defaultOptions = {
    method: 'POST',
    headers: {
        'Content-Type': batchRequestContent
    }
};

function buildRequest(url, req) {
    const body = [];
    const options = merge({headers: {}, method: 'GET'}, req);
    //this is what fetch appears to do by default
    const dedupedHeaders = Object.keys(options.headers).reduce((headers, header) => {
        const lowerHeader = header.toLowerCase();
        if (headers[lowerHeader]) {
            headers[lowerHeader] += ',' + options.headers[header]; // eslint-disable-line prefer-template
        } else {
            headers[lowerHeader] = options.headers[header];
        }
        return headers;
    }, {});

    body.push(boundarySeparator + boundaryString);
    body.push(batchItemContent);

    body.push('');

    body.push(`${options.method.toUpperCase()} ${url} ${httpVersion}`);

    body.push(`Host: ${window.location.host}`);

    Object.keys(dedupedHeaders).forEach(function(header) {
        body.push(`${header}: ${dedupedHeaders[header]}`);
    });

    body.push('');

    if (options.body) {
        body.push(options.body);
    } else {
        body.push('');
    }

    body.push('');

    return body.join(newLine);
}

function parseResponse(response) {
    const parsedResponse = {};
    const resp = response.replace(new RegExp('[^]*?' + httpVersion), httpVersion); // eslint-disable-line prefer-template
    const respLines = resp.split(newLine);
    const versionLine = respLines.shift().split(' ');
    versionLine.shift();

    const status = versionLine.shift();
    const message = versionLine;
    parsedResponse.status = status;
    parsedResponse.statusMessage = message.join(' ');
    parsedResponse.headers = {};

    while (respLines[0] !== '') {
        const [headerName, headerValue] = respLines.shift().split(': ');
        parsedResponse.headers[headerName] = headerValue;
    }

    respLines.shift();
    parsedResponse.body = respLines.shift();
    return parsedResponse;
}

function parseBatchedResponse(res, headers) {
    const separator = '--' + /boundary="(.*)"/.exec(headers.get('Content-Type'))[1]; // eslint-disable-line prefer-template
    const responses = res.split(separator).filter((resp) => resp.replace(newLine, '') !== boundarySeparator && resp.replace(newLine, '').length);

    return responses.map((resp) => {
        const parsedResponse = parseResponse(resp);
        return new Response(parsedResponse.body, parsedResponse);
    });
}

export function batchFetch(url, requests, options) {
    // eslint-disable-next-line prefer-spread
    let body = requests.map(req => buildRequest.apply(null, req)).join('');
    body += boundarySeparator + boundaryString + boundarySeparator;

    return fetch(url, extend({}, defaultOptions, {body}, options))
        .then(function(response) {
            if (!response.ok) {
                return {
                    response,
                    parsedResponses: []
                };
            }

            return response.text().then(function(text) {
                const responses = parseBatchedResponse(text, response.headers);
                return {
                    response,
                    parsedResponses: responses
                };
            });
        });
}
